/* eslint-disable radix */
export const operators = {
  answered: ["radio", "dropdown", "multipleChoice", "scale", "short-text", "checkbox"],
  skipped: ["radio", "dropdown", "multipleChoice", "scale", "short-text", "checkbox"],
  selected: ["radio", "dropdown", "multipleChoice", "checkbox"],
  "not-selected": ["radio", "dropdown", "multipleChoice", "checkbox"],
  "less-than": ["scale"],
  equals: ["scale"],
  "not-equals": ["scale"],
  "greater-than": ["scale"]
}

const toSelectedIds = answeredValue => {
  if (answeredValue == null) return []
  if (answeredValue instanceof Array) return answeredValue
  if (answeredValue.values || answeredValue.otherValues) {
    return [
      ...(answeredValue.values || []),
      ...(answeredValue.otherValues || []).map(o => o.optionId)
    ]
  }
  return [answeredValue]
}

const evaluateLogicRow = (answeredValue, operator, value) => {
  switch (operator) {
    case "answered":
      return !!answeredValue
    case "skipped":
      return !answeredValue
    case "selected": {
      const ids = toSelectedIds(answeredValue)
      return ids.length > 0 ? ids.includes(value) : answeredValue === value
    }
    case "not-selected": {
      const ids = toSelectedIds(answeredValue)
      return ids.length > 0 ? !ids.includes(value) : answeredValue === value
    }
    case "less-than":
      return answeredValue instanceof Array
        ? answeredValue[0] < parseInt(value)
        : answeredValue < parseInt(value)
    case "equals":
      return answeredValue instanceof Array
        ? answeredValue[0] === parseInt(value)
        : answeredValue === parseInt(value)
    case "not-equals":
      return answeredValue instanceof Array
        ? answeredValue[0] !== parseInt(value)
        : answeredValue !== parseInt(value)
    case "greater-than":
      return answeredValue instanceof Array
        ? answeredValue[0] > parseInt(value)
        : answeredValue > parseInt(value)
    default:
      return true
  }
}
const evaluateLogic = (logicArray, allAnswers) => {
  return logicArray.reduce((result, logic) => {
    const { questionId, operator, value, condition } = logic
    const answer = allAnswers.find(a => a.questionId === questionId)
    const answeredValue = answer?.value
    const evaluation = evaluateLogicRow(answeredValue, operator, value)
    if (condition === "and") {
      return result && evaluation
    }
    return result || evaluation
  }, false)
}
export const isChoiceVisible = (val, allAnswers, choiceLogics) => {
  const choiceId = val.id
  const choiceLogic = choiceLogics?.find(
    logic => logic.appliedChoiceId === choiceId
  )
  if (!choiceLogic) return true
  const result = evaluateLogic(choiceLogic.logic, allAnswers)
  return result
}
export const isQuestionVisible = (
  idx,
  allAnswers,
  questionLogics,
  setAnswer
) => {
  const id = idx.toString()
  const questionLogic = questionLogics?.find(
    logic => logic.appliedQuestionId === id
  )
  if (!questionLogic) return true
  setAnswer(null)
  const result = evaluateLogic(questionLogic.logic, allAnswers)
  return result
}
